import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { BaseService } from '../../templates/services/base-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Core2Config } from '../../utils/core2-config';
import { getHttpHeader } from '../../utils/http-header.factory';
import { TokenizeContainerModel } from '../../models/tokenize/tokenize-container.model';

@Injectable({
  providedIn: 'root'
})
export class TokenizeService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/ambank/duitnow-transfer/tokenize';

  constructor(protected readonly http: HttpClient) {}

  public tokenize(data: { debitorAccountNo: string, debitorAccType: 'A7_UNIPIN_CA_3071' | 'A6_TTS_DNOBW_8135' }, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<TokenizeContainerModel>>{
    return this.http.post<ApiResponseModel<TokenizeContainerModel>>(`${ api_domain_url }${ this.apiUrl }/${ tenantCode }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
